export const CompanyStatusEnum = {
  live: 'live',
  closed: 'closed',
  not_reported: 'not_reported',
} as const;
export type CompanyStatusEnum =
  (typeof CompanyStatusEnum)[keyof typeof CompanyStatusEnum];
